// extracted by mini-css-extract-plugin
module.exports = {"nb-root":"NavBrand_nb-root__29Z0v","img":"NavBrand_img__1Hisb"};